// extracted by mini-css-extract-plugin
export var image = "c6_dc";